import { render, staticRenderFns } from "./MailingsMessageDetailsRecipientSelect.vue?vue&type=template&id=3c2880f7&scoped=true&"
import script from "./MailingsMessageDetailsRecipientSelect.vue?vue&type=script&lang=ts&"
export * from "./MailingsMessageDetailsRecipientSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2880f7",
  null
  
)

export default component.exports